// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HelpPage_Hrrkq {
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);


  .HelpPageBody_dzNik {
    gap: 20px;
    width: calc(100% - 60px);
    height: calc(100vh - 130px);
    position: relative;
    display: inline-flex;
    overflow: hidden;
    padding: 60px 30px 20px;

    .HelpPageBodyLeft_WcF5w {
      width: 100%;
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        display: none;
      }

      .searchArticleContainer_BcbuF {
        width: 100%;
        margin: 0 auto;
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @media (width<=768px) {
          width: 100%;
        }

        h3 {
          margin: 0;
          color: #1F1F1F;

          svg {
            width: 16px;
            height: 16px;
          }
        }

        p {
          color: #676767;

        }

        .inputContainer_vJivO {
          width: 70%;
          position: relative;
          display: inline-flex;
          gap: 5px;

          
          button{
            border: none;
            border-radius: 8px;
            padding: 2px 10px;
            cursor: pointer;

            &.deleteButton_UCFdm {
              background-color: #dc3545;
              color: white;  
              &:hover {
                background-color: #c82333;
              }
            }

            &.addButton_fSIaT {
              background-color: var(--f5-background);
              color: #000;
              &:hover {
                background-color: #e9ecef;
              }
            }
          }

          .searchContainerIcon_O7_b3 {
            background-color: var(--ececf1-background);
            padding: 4px;
            border-radius: 4px;
            height: 10px;
            width: 10px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            -ms-border-radius: 4px;
            -o-border-radius: 4px;
            cursor: pointer;
          }


        }
      }
    }

    .HelpPageBodyRight_PnsXD {
      max-width: 300px;
    }
  }
}

.recomendQuestions_DQhCZ {
  cursor: pointer;
  position: absolute;
  background-color: var(--white-color);
  display: flex;
  flex-direction: column;
  border: 1px solid #D9D9E3;
  top: calc(100% + 5px);
  width: 100%;
  max-height: 50vh;
  overflow-y: scroll;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;
  scrollbar-width: none;

  >div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .articleItem_RaRf3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #D9D9E3;
    padding: 10px;
    box-sizing: border-box;
    gap: 10px;

    svg {
      fill: var(--_2-color);
      min-width: 10px;
      min-height: 10px;
    }

    >div {
      text-align: start;
      display: flex;
      flex-direction: column;
    }

    p {
      margin: 0;
      width: fit-content;

    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}



.upgradeNotesContainerList_xX1v9 {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .upgradeNotesItem_ZWk88 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    padding: 20px 20px 20px 40px;

    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 14px;
      width: 1px;
      height: 50%;
      background: #dadada;
      z-index: 0;
    }

    label {
      z-index: 1;
      font-size: 11px;
      font-weight: 400;
      color: #717171;
      transform: rotate(90deg) translate(calc(100% - 10px), 30px);
      position: absolute;
      top: 0px;
      left: 0px;
      height: 0px;
      width: 86px;
      text-transform: uppercase;
      font-weight: 700;
      background: #ffff;
      padding: 10px;
      border: 1px solid #71717171;
      padding: 0px;
      height: 22px;
      text-align: center;
      line-height: 23px;
      border-radius: 10px;


    }

    h3 {
      font-size: 16px;
      font-weight: 500;
      margin: 0px;
    }

    p {
      font-size: 14px;
      margin: 0px;
    }
  }
}




.upgradeNotesContainer_PrEur {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .upgradeNotesHeader_Wx6XD {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #D9D9E3;

    h2 {
      margin: 0;
      color: #1F1F1F;
      font-size: 24px;
      font-weight: 600;
    }


  }


  .formActions_qddMA {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin: 10px 0px 0px;

    button {
      padding: 10px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      border: none;
      background: var(--f5-background);
      color: #000000;
    }

    .saveButton_uiLqt {
      background-color: #10a37f40;
      color: #10a37f;
      transition: background-color 0.2s;

      &:hover:not(:disabled) {
        background-color: #10a37f75;
      }

      &:disabled {
        background-color: var(--f5-background);
        color: #000;
        cursor: not-allowed;
      }
    }

    .deleteAllButton_SRRIy {
      background-color: #dc354524;
      color: #dc3545;
      transition: background-color 0.2s;

      &:hover {
        background-color: #dc35453b;
      }
    }
  }

  .upgradeNotesForm_efBtq {
    display: flex;
    flex-direction: column;

  
  }

  .formGroup_bikOH {
    display: flex;
    flex-direction: column;

    label {
      font-weight: 600;
      color: #1F1F1F;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 0px;
      text-transform: uppercase;
    }

    input {
      padding: 10px 4px;
      border: none;
      border-bottom: 1px solid #D9D9E3;
      background: transparent;
      /* border-radius: 8px; */
      font-size: 14px;
      border-radius: 0px;
      transition: border-color 0.2s;
      outline: none;
      font-family: 'Inter';
      color: #ccc;

      &::placeholder {
        color: #999;
      }
    }
  }


  /* .notesList {
    margin-top: 30px;

    h3 {
      margin: 0 0 20px 0;
      color: #1F1F1F;
      font-size: 20px;
      font-weight: 600;
    }
  } */

  .editorToolbar_Pb9Mx {
    display: flex;
    gap: 5px;
    padding: 6px 2px;

    .toolbarButton_a6ucd {
      padding: 6px 12px;
      background: white;
      border: 1px solid #D9D9E3;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 30px;
      color: #000;

      &:hover {
        background: #e9ecef;
        border-color: #10a37f;
      }

      &:active {
        background: #dee2e6;
      }

      strong,
      em,
      u {
        font-weight: bold;
        font-style: normal;
        text-decoration: none;
        color: var(--black-color);
      }
    }
  }


  .editorContent_VMV48 {
    min-height: 60px;
    max-height: 400px;
    padding: 15px 2px;
    border-bottom: 1px solid #D9D9E3;
    font-size: 14px;
    line-height: 1.6;
    outline: none;
    overflow-y: hidden;
    position: relative;
    transition: height 0.2s ease;
    resize: none;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 10px 0 5px 0;
      color: #1F1F1F;
      font-weight: 600;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      margin: 0 0 10px 0;
    }

    ul,
    ol {
      margin: 10px 0;
      padding-left: 20px;
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      margin: 10px 0;
    }

    a {
      color: #10a37f;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    strong {
      font-weight: bold;
    }

    em {
      font-style: italic;
    }

    u {
      text-decoration: underline;
    }
  }



  textarea {
    width: 100%;
    height: 100px;
    border: none;
    border-bottom: 1px solid #D9D9E3;
    background: transparent;
    /* border-radius: 8px; */
    padding: 10px 4px;
    font-size: 15px;
    outline: none;
    font-family: 'Inter';
    color: #ccc;
  }

  button {
    width: 100%;
    background-color: var(--_10a37f-background);
    color: var(--white-color);
    border: none;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
}



.upgradeNotesItem_ZWk88 {
  .upgradeNotesItemButtons_qNtCT {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-bottom: 10px;

    button {
      border: none;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      background-color: var(--f5-background);
      color: #1F1F1F;

      &.deleteButton_UCFdm {
        background-color: #dc3545;
        color: #fff;
      }
    }
  }

  .noteHeader_RxHBW {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    h4 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #1F1F1F;
    }

    .noteActions_Km5H6 {
      display: flex;
      gap: 10px;

      .editButton_cSouR {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 6px 12px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        transition: background-color 0.2s;

        &:hover {
          background-color: #0056b3;
        }
      }

      .deleteButton_UCFdm {
        background-color: #dc3545;
        color: white;
        border: none;
        padding: 6px 12px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        transition: background-color 0.2s;

        &:hover {
          background-color: #c82333;
        }
      }
    }
  }

  .noteDate_hBq2W {
    font-size: 12px;
    color: #717171;
    margin: 0 0 10px 0;
    font-weight: 500;
  }

  .noteContent_v1mIM {
    font-size: 14px;
    line-height: 1.6;
    color: #333;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 10px 0 5px 0;
      color: #1F1F1F;
    }

    p {
      margin: 0 0 10px 0;
    }

    ul,
    ol {
      margin: 10px 0;
      padding-left: 20px;
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      margin: 10px 0;
    }

    a {
      color: #10a37f;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

/* Loading Styles */
.loadingContainer_QzHPq {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
}

.loadingSpinner_gJFVo {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin__iKyq 1s linear infinite;
}

@keyframes spin__iKyq {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}



@media (max-width: 768px) {
  .HelpPageBody_dzNik {
    height: unset;
    flex-direction: column-reverse;
  }
  .recomendQuestions_DQhCZ{
    top: unset !important;
    max-height: unset !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/UpgradePage/UpgradePage.module.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;;;EAG7D;IACE,SAAS;IACT,wBAAwB;IACxB,2BAA2B;IAC3B,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;;IAEvB;MACE,WAAW;MACX,kBAAkB;MAClB,kBAAkB;;MAElB;QACE,aAAa;MACf;;MAEA;QACE,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;;QAEvB;UACE,WAAW;QACb;;QAEA;UACE,SAAS;UACT,cAAc;;UAEd;YACE,WAAW;YACX,YAAY;UACd;QACF;;QAEA;UACE,cAAc;;QAEhB;;QAEA;UACE,UAAU;UACV,kBAAkB;UAClB,oBAAoB;UACpB,QAAQ;;;UAGR;YACE,YAAY;YACZ,kBAAkB;YAClB,iBAAiB;YACjB,eAAe;;YAEf;cACE,yBAAyB;cACzB,YAAY;cACZ;gBACE,yBAAyB;cAC3B;YACF;;YAEA;cACE,sCAAsC;cACtC,WAAW;cACX;gBACE,yBAAyB;cAC3B;YACF;UACF;;UAEA;YACE,0CAA0C;YAC1C,YAAY;YACZ,kBAAkB;YAClB,YAAY;YACZ,WAAW;YACX,0BAA0B;YAC1B,uBAAuB;YACvB,sBAAsB;YACtB,qBAAqB;YACrB,eAAe;UACjB;;;QAGF;MACF;IACF;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,qBAAqB;MACrB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,SAAS;MACT,kBAAkB;;IAEpB;EACF;;EAEA;IACE,aAAa;EACf;AACF;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,4BAA4B;;IAE5B;MACE,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,UAAU;MACV,WAAW;MACX,mBAAmB;MACnB,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,2DAA2D;MAC3D,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,WAAW;MACX,WAAW;MACX,yBAAyB;MACzB,gBAAgB;MAChB,iBAAiB;MACjB,aAAa;MACb,2BAA2B;MAC3B,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB;;;IAGrB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,eAAe;MACf,WAAW;IACb;EACF;AACF;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;;IAEhC;MACE,SAAS;MACT,cAAc;MACd,eAAe;MACf,gBAAgB;IAClB;;;EAGF;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,oBAAoB;;IAEpB;MACE,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,gCAAgC;MAChC,cAAc;IAChB;;IAEA;MACE,2BAA2B;MAC3B,cAAc;MACd,iCAAiC;;MAEjC;QACE,2BAA2B;MAC7B;;MAEA;QACE,sCAAsC;QACtC,WAAW;QACX,mBAAmB;MACrB;IACF;;IAEA;MACE,2BAA2B;MAC3B,cAAc;MACd,iCAAiC;;MAEjC;QACE,2BAA2B;MAC7B;IACF;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;;;EAGxB;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,gBAAgB;MAChB,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,iBAAiB;MACjB,YAAY;MACZ,gCAAgC;MAChC,uBAAuB;MACvB,wBAAwB;MACxB,eAAe;MACf,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,oBAAoB;MACpB,WAAW;;MAEX;QACE,WAAW;MACb;IACF;EACF;;;EAGA;;;;;;;;;KASG;;EAEH;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;;IAEhB;MACE,iBAAiB;MACjB,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,WAAW;;MAEX;QACE,mBAAmB;QACnB,qBAAqB;MACvB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;;;QAGE,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;MAC3B;IACF;EACF;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;;IAEZ;;;;;;MAME,oBAAoB;MACpB,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,qBAAqB;;MAErB;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;EACF;;;;EAIA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2CAA2C;IAC3C,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;AACF;;;;AAIA;EACE;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,mBAAmB;;IAEnB;MACE,YAAY;MACZ,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,sCAAsC;MACtC,cAAc;;MAEd;QACE,yBAAyB;QACzB,WAAW;MACb;IACF;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,SAAS;;MAET;QACE,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,iCAAiC;;QAEjC;UACE,yBAAyB;QAC3B;MACF;;MAEA;QACE,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,iCAAiC;;QAEjC;UACE,yBAAyB;QAC3B;MACF;IACF;EACF;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;;IAEX;;;;;;MAME,oBAAoB;MACpB,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,qBAAqB;;MAErB;QACE,0BAA0B;MAC5B;IACF;EACF;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;AACF","sourcesContent":[".HelpPage {\n  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);\n\n\n  .HelpPageBody {\n    gap: 20px;\n    width: calc(100% - 60px);\n    height: calc(100vh - 130px);\n    position: relative;\n    display: inline-flex;\n    overflow: hidden;\n    padding: 60px 30px 20px;\n\n    .HelpPageBodyLeft {\n      width: 100%;\n      overflow-y: scroll;\n      overflow-x: hidden;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .searchArticleContainer {\n        width: 100%;\n        margin: 0 auto;\n        text-align: left;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n\n        @media (width<=768px) {\n          width: 100%;\n        }\n\n        h3 {\n          margin: 0;\n          color: #1F1F1F;\n\n          svg {\n            width: 16px;\n            height: 16px;\n          }\n        }\n\n        p {\n          color: #676767;\n\n        }\n\n        .inputContainer {\n          width: 70%;\n          position: relative;\n          display: inline-flex;\n          gap: 5px;\n\n          \n          button{\n            border: none;\n            border-radius: 8px;\n            padding: 2px 10px;\n            cursor: pointer;\n\n            &.deleteButton {\n              background-color: #dc3545;\n              color: white;  \n              &:hover {\n                background-color: #c82333;\n              }\n            }\n\n            &.addButton {\n              background-color: var(--f5-background);\n              color: #000;\n              &:hover {\n                background-color: #e9ecef;\n              }\n            }\n          }\n\n          .searchContainerIcon {\n            background-color: var(--ececf1-background);\n            padding: 4px;\n            border-radius: 4px;\n            height: 10px;\n            width: 10px;\n            -webkit-border-radius: 4px;\n            -moz-border-radius: 4px;\n            -ms-border-radius: 4px;\n            -o-border-radius: 4px;\n            cursor: pointer;\n          }\n\n\n        }\n      }\n    }\n\n    .HelpPageBodyRight {\n      max-width: 300px;\n    }\n  }\n}\n\n.recomendQuestions {\n  cursor: pointer;\n  position: absolute;\n  background-color: var(--white-color);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #D9D9E3;\n  top: calc(100% + 5px);\n  width: 100%;\n  max-height: 50vh;\n  overflow-y: scroll;\n  border-radius: 12px;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  -ms-border-radius: 12px;\n  -o-border-radius: 12px;\n  scrollbar-width: none;\n\n  >div {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .articleItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    border-bottom: 1px solid #D9D9E3;\n    padding: 10px;\n    box-sizing: border-box;\n    gap: 10px;\n\n    svg {\n      fill: var(--_2-color);\n      min-width: 10px;\n      min-height: 10px;\n    }\n\n    >div {\n      text-align: start;\n      display: flex;\n      flex-direction: column;\n    }\n\n    p {\n      margin: 0;\n      width: fit-content;\n\n    }\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n\n\n.upgradeNotesContainerList {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  .upgradeNotesItem {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    position: relative;\n    padding: 20px 20px 20px 40px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0px;\n      left: 14px;\n      width: 1px;\n      height: 50%;\n      background: #dadada;\n      z-index: 0;\n    }\n\n    label {\n      z-index: 1;\n      font-size: 11px;\n      font-weight: 400;\n      color: #717171;\n      transform: rotate(90deg) translate(calc(100% - 10px), 30px);\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      height: 0px;\n      width: 86px;\n      text-transform: uppercase;\n      font-weight: 700;\n      background: #ffff;\n      padding: 10px;\n      border: 1px solid #71717171;\n      padding: 0px;\n      height: 22px;\n      text-align: center;\n      line-height: 23px;\n      border-radius: 10px;\n\n\n    }\n\n    h3 {\n      font-size: 16px;\n      font-weight: 500;\n      margin: 0px;\n    }\n\n    p {\n      font-size: 14px;\n      margin: 0px;\n    }\n  }\n}\n\n\n\n\n.upgradeNotesContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  .upgradeNotesHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0;\n    border-bottom: 1px solid #D9D9E3;\n\n    h2 {\n      margin: 0;\n      color: #1F1F1F;\n      font-size: 24px;\n      font-weight: 600;\n    }\n\n\n  }\n\n\n  .formActions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    margin: 10px 0px 0px;\n\n    button {\n      padding: 10px 20px;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 12px;\n      font-weight: 500;\n      border: none;\n      background: var(--f5-background);\n      color: #000000;\n    }\n\n    .saveButton {\n      background-color: #10a37f40;\n      color: #10a37f;\n      transition: background-color 0.2s;\n\n      &:hover:not(:disabled) {\n        background-color: #10a37f75;\n      }\n\n      &:disabled {\n        background-color: var(--f5-background);\n        color: #000;\n        cursor: not-allowed;\n      }\n    }\n\n    .deleteAllButton {\n      background-color: #dc354524;\n      color: #dc3545;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #dc35453b;\n      }\n    }\n  }\n\n  .upgradeNotesForm {\n    display: flex;\n    flex-direction: column;\n\n  \n  }\n\n  .formGroup {\n    display: flex;\n    flex-direction: column;\n\n    label {\n      font-weight: 600;\n      color: #1F1F1F;\n      font-size: 12px;\n      margin-top: 10px;\n      margin-bottom: 0px;\n      text-transform: uppercase;\n    }\n\n    input {\n      padding: 10px 4px;\n      border: none;\n      border-bottom: 1px solid #D9D9E3;\n      background: transparent;\n      /* border-radius: 8px; */\n      font-size: 14px;\n      border-radius: 0px;\n      transition: border-color 0.2s;\n      outline: none;\n      font-family: 'Inter';\n      color: #ccc;\n\n      &::placeholder {\n        color: #999;\n      }\n    }\n  }\n\n\n  /* .notesList {\n    margin-top: 30px;\n\n    h3 {\n      margin: 0 0 20px 0;\n      color: #1F1F1F;\n      font-size: 20px;\n      font-weight: 600;\n    }\n  } */\n\n  .editorToolbar {\n    display: flex;\n    gap: 5px;\n    padding: 6px 2px;\n\n    .toolbarButton {\n      padding: 6px 12px;\n      background: white;\n      border: 1px solid #D9D9E3;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 12px;\n      font-weight: 500;\n      transition: all 0.2s;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 30px;\n      color: #000;\n\n      &:hover {\n        background: #e9ecef;\n        border-color: #10a37f;\n      }\n\n      &:active {\n        background: #dee2e6;\n      }\n\n      strong,\n      em,\n      u {\n        font-weight: bold;\n        font-style: normal;\n        text-decoration: none;\n        color: var(--black-color);\n      }\n    }\n  }\n\n\n  .editorContent {\n    min-height: 60px;\n    max-height: 400px;\n    padding: 15px 2px;\n    border-bottom: 1px solid #D9D9E3;\n    font-size: 14px;\n    line-height: 1.6;\n    outline: none;\n    overflow-y: hidden;\n    position: relative;\n    transition: height 0.2s ease;\n    resize: none;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 10px 0 5px 0;\n      color: #1F1F1F;\n      font-weight: 600;\n    }\n\n    h1 {\n      font-size: 24px;\n    }\n\n    h2 {\n      font-size: 20px;\n    }\n\n    h3 {\n      font-size: 18px;\n    }\n\n    p {\n      margin: 0 0 10px 0;\n    }\n\n    ul,\n    ol {\n      margin: 10px 0;\n      padding-left: 20px;\n    }\n\n    img {\n      max-width: 100%;\n      height: auto;\n      border-radius: 8px;\n      margin: 10px 0;\n    }\n\n    a {\n      color: #10a37f;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    strong {\n      font-weight: bold;\n    }\n\n    em {\n      font-style: italic;\n    }\n\n    u {\n      text-decoration: underline;\n    }\n  }\n\n\n\n  textarea {\n    width: 100%;\n    height: 100px;\n    border: none;\n    border-bottom: 1px solid #D9D9E3;\n    background: transparent;\n    /* border-radius: 8px; */\n    padding: 10px 4px;\n    font-size: 15px;\n    outline: none;\n    font-family: 'Inter';\n    color: #ccc;\n  }\n\n  button {\n    width: 100%;\n    background-color: var(--_10a37f-background);\n    color: var(--white-color);\n    border: none;\n    padding: 10px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n\n\n\n.upgradeNotesItem {\n  .upgradeNotesItemButtons {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n\n    button {\n      border: none;\n      cursor: pointer;\n      font-size: 12px;\n      font-weight: 500;\n      background-color: var(--f5-background);\n      color: #1F1F1F;\n\n      &.deleteButton {\n        background-color: #dc3545;\n        color: #fff;\n      }\n    }\n  }\n\n  .noteHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n\n    h4 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #1F1F1F;\n    }\n\n    .noteActions {\n      display: flex;\n      gap: 10px;\n\n      .editButton {\n        background-color: #007bff;\n        color: white;\n        border: none;\n        padding: 6px 12px;\n        border-radius: 6px;\n        cursor: pointer;\n        font-size: 12px;\n        font-weight: 500;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: #0056b3;\n        }\n      }\n\n      .deleteButton {\n        background-color: #dc3545;\n        color: white;\n        border: none;\n        padding: 6px 12px;\n        border-radius: 6px;\n        cursor: pointer;\n        font-size: 12px;\n        font-weight: 500;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: #c82333;\n        }\n      }\n    }\n  }\n\n  .noteDate {\n    font-size: 12px;\n    color: #717171;\n    margin: 0 0 10px 0;\n    font-weight: 500;\n  }\n\n  .noteContent {\n    font-size: 14px;\n    line-height: 1.6;\n    color: #333;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 10px 0 5px 0;\n      color: #1F1F1F;\n    }\n\n    p {\n      margin: 0 0 10px 0;\n    }\n\n    ul,\n    ol {\n      margin: 10px 0;\n      padding-left: 20px;\n    }\n\n    img {\n      max-width: 100%;\n      height: auto;\n      border-radius: 8px;\n      margin: 10px 0;\n    }\n\n    a {\n      color: #10a37f;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n/* Loading Styles */\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  width: 100%;\n}\n\n.loadingSpinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n@media (max-width: 768px) {\n  .HelpPageBody {\n    height: unset;\n    flex-direction: column-reverse;\n  }\n  .recomendQuestions{\n    top: unset !important;\n    max-height: unset !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HelpPage": `HelpPage_Hrrkq`,
	"HelpPageBody": `HelpPageBody_dzNik`,
	"HelpPageBodyLeft": `HelpPageBodyLeft_WcF5w`,
	"searchArticleContainer": `searchArticleContainer_BcbuF`,
	"inputContainer": `inputContainer_vJivO`,
	"deleteButton": `deleteButton_UCFdm`,
	"addButton": `addButton_fSIaT`,
	"searchContainerIcon": `searchContainerIcon_O7_b3`,
	"HelpPageBodyRight": `HelpPageBodyRight_PnsXD`,
	"recomendQuestions": `recomendQuestions_DQhCZ`,
	"articleItem": `articleItem_RaRf3`,
	"upgradeNotesContainerList": `upgradeNotesContainerList_xX1v9`,
	"upgradeNotesItem": `upgradeNotesItem_ZWk88`,
	"upgradeNotesContainer": `upgradeNotesContainer_PrEur`,
	"upgradeNotesHeader": `upgradeNotesHeader_Wx6XD`,
	"formActions": `formActions_qddMA`,
	"saveButton": `saveButton_uiLqt`,
	"deleteAllButton": `deleteAllButton_SRRIy`,
	"upgradeNotesForm": `upgradeNotesForm_efBtq`,
	"formGroup": `formGroup_bikOH`,
	"editorToolbar": `editorToolbar_Pb9Mx`,
	"toolbarButton": `toolbarButton_a6ucd`,
	"editorContent": `editorContent_VMV48`,
	"upgradeNotesItemButtons": `upgradeNotesItemButtons_qNtCT`,
	"noteHeader": `noteHeader_RxHBW`,
	"noteActions": `noteActions_Km5H6`,
	"editButton": `editButton_cSouR`,
	"noteDate": `noteDate_hBq2W`,
	"noteContent": `noteContent_v1mIM`,
	"loadingContainer": `loadingContainer_QzHPq`,
	"loadingSpinner": `loadingSpinner_gJFVo`,
	"spin": `spin__iKyq`
};
export default ___CSS_LOADER_EXPORT___;
